import config from '../../app-config';


export default class Api {
	static signUp( values ) {
		return fetch(config.URL + `/api/user/sign-up`, {
			method: 'post',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ user: values })
		})
	}

	static Login( values ) {
		return fetch(config.URL + `/api/user/login`, {
			method: 'post',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ user: values })
		})
	}

	static ResendLink( values ) {
		return fetch(config.URL + `/api/user/resend-link`, {
			method: 'post',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(values)
		})
	}

	static getUser() {
		return fetch(config.URL + `/api/user/me`);
	}

	static checkVerifyToken( verifyToken ) {
		return fetch(config.URL + `/api/user/verify-token`, {
			method: 'put',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ verify_token: verifyToken })
		})
	}

	static ForgotPasswordSendEmail( email ) {
		return fetch(config.URL + `/api/user/forgot-password`, {
			method: 'post',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ email })
		})
	}

	static getUserByVerificationToken( verify_token ) {
		return fetch(config.URL + `/api/user/getUser-by-verifyToken`, {
			method: 'post',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ verify_token })
		})
	}
	static resetPassword(newPassword, verify_token){
		return fetch(config.URL + `/api/user/reset-password`, {
			method: 'put',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ newPassword, verify_token })
		})
	}

}
